import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {BulkAction} from "../model/bulk/bulkAction";
import {environment} from "../../environments/environment";
import {BulkActionRequest} from "../model/bulk/bulkActionRequest";

@Injectable({
  providedIn: 'root'
})
export class BulkActionService {

  private readonly API_PREFIX = environment.apiUrlBulkPrefix;

  private http = inject(HttpClient);

  public createBulkAction(bulkActionRequest: BulkActionRequest): Observable<BulkAction> {
    return this.http.post<BulkAction>(this.API_PREFIX + 'devices', bulkActionRequest);
  }

  public findById(bulkActionId: number): Observable<BulkAction> {
    return this.http.get<BulkAction>(this.API_PREFIX + bulkActionId);
  }

  public findByImei(imei: string): Observable<BulkAction[]> {
    return this.http.get<BulkAction[]>(this.API_PREFIX + 'imei/' + imei);
  }

  public getAll(): Observable<BulkAction[]> {
    return this.http.get<BulkAction[]>(this.API_PREFIX.substring(0, this.API_PREFIX.length - 1));
  }
}
